import { createPlugin } from '@i18n/utils'

export default async ({ store, route }, inject) => {
  const locale = store.getters['config/locale']
  const currencyCode = store.getters['config/currencyCode']

  const plugin = createPlugin({
    locale,
    currencyCode,
    showTranslationKeys: route.query.showTranslationKeys,
  })

  inject('t', plugin)
}
